import React from "react";
import { Route, Switch } from "react-router-dom";
import VehicleTracker from "./containers/VehicleTracker";

const Routes = () =>
  <Switch>
    <Route path="/track/:id" component={VehicleTracker} />
  </Switch>;

export default Routes;
